import React from 'react';
import './DomRouting.scss';

const DomRouting = () => {

  return (

    <div className="main-right-side-section">
      <div className="routing-main-section">
        <section>
          <div className="routing-section-1">
            <div className="routing-section-1-inner">
              <p>DomRouting Component</p>
            </div>
          </div>
        </section>
      </div>
    </div>

  );
}

DomRouting.propTypes = {};

DomRouting.defaultProps = {};

export default DomRouting;
